import {
  FETCH_NETWORK_TYPES,
  FETCH_NETWORK_TYPES_LOADING,
  FETCH_COLLABORATOR_TYPE,
  FETCH_COLLABORATOR_TYPE_LOADING,
  UPDATE_NETWORK_DETAILS,
  UPDATE_PARTNER_DETAILS,
  ADD_NETWORK_DETAILS,
  ADD_PARTNER_DETAILS,
  DELETE_NETWORK_TYPE,
  DELETE_PARTNER_TYPE,
  GET_NETWORK_ROLES,
  GET_NETWORK_ROLES_LOADING,
  ADD_SPONSOR_NETWORK_DETAILS,
  FETCH_ALL_SPONSOR_NETWORKS,
  FETCH_ALL_SPONSOR_NETWORKS_LOADING,
  FETCH_SELECTED_SPONSOR_DETAILS,
  FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
  SEND_NETWORK_INVITATION,
  UPDATE_SPONSOR_NETWORK_DETAILS,
  SAVE_NETWORK_CONFIGURATION_PROGRESS,
} from "../actions/types";

const initialState = {
  networkDetails: {},
  fetchNetworkTypeLoading: true,
  getAllRolesLoading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_NETWORK_TYPES:
      return {
        ...state,
        networkDetails: action.payload,
      };
    case FETCH_NETWORK_TYPES_LOADING:
      return {
        ...state,
        fetchNetworkTypeLoading: action.payload,
      };
    case FETCH_COLLABORATOR_TYPE:
      return {
        ...state,
        partnerDetails: action.payload,
      };
    case FETCH_COLLABORATOR_TYPE_LOADING:
      return {
        ...state,
        partnerDetailsTypeLoading: action.payload,
      };
    case UPDATE_NETWORK_DETAILS:
      return {
        ...state,
        updateNetworkDetails: action.payload,
      };
    case UPDATE_PARTNER_DETAILS:
      return {
        ...state,
        updatePartnerDetails: action.payload,
      };
    case ADD_NETWORK_DETAILS:
      return {
        ...state,
        addNetworkDetails: action.payload,
      };
    case ADD_PARTNER_DETAILS:
      return {
        ...state,
        addPartnerDetails: action.payload,
      };
    case DELETE_NETWORK_TYPE:
      return {
        ...state,
        deleteNetwork: action.payload,
      };
    case DELETE_PARTNER_TYPE:
      return {
        ...state,
        deletePartner: action.payload,
      };
    case GET_NETWORK_ROLES:
      return {
        ...state,
        getAllRoles: action.payload,
      };
    case GET_NETWORK_ROLES_LOADING:
      return {
        ...state,
        getAllRolesLoading: action.payload,
      };
    case ADD_SPONSOR_NETWORK_DETAILS:
      return {
        ...state,
        addSponsorDetails: action.payload,
      };
    case FETCH_ALL_SPONSOR_NETWORKS:
      return {
        ...state,
        sponsorNetwork: action.payload,
      };
    case FETCH_ALL_SPONSOR_NETWORKS_LOADING:
      return {
        ...state,
        sponsorNetworkLoading: action.payload,
      };
    case FETCH_SELECTED_SPONSOR_DETAILS:
      return {
        ...state,
        selectedSponsorDetails: action.payload,
      };
    case FETCH_SELECTED_SPONSOR_DETAILS_LOADING:
      return {
        ...state,
        selectedSponsorDetailsLoading: action.payload,
      };
    case SEND_NETWORK_INVITATION: //new
      return {
        ...state,
        sendInvite: action.payload,
      };
    case UPDATE_SPONSOR_NETWORK_DETAILS:
      return {
        ...state,
        updateSponsorDetails: action.payload,
      };
    case SAVE_NETWORK_CONFIGURATION_PROGRESS:
      return {
        ...state,
        saveNetworkConfiguration: action.payload,
      };
    default:
      return state;
  }
}
